import { DeviceDetectorService } from 'ngx-device-detector';

export class BookingBase {
  isMobile: boolean;

  constructor(protected deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile();
  }
}
